// extracted by mini-css-extract-plugin
export var songs = "HomeSongs-module--songs--vQCfi";
export var songs_header = "HomeSongs-module--songs_header--yC+jA";
export var songs_title = "HomeSongs-module--songs_title--qOMYQ";
export var songs_more_button = "HomeSongs-module--songs_more_button--g0QLL";
export var icon = "HomeSongs-module--icon--Boj--";
export var carousel_slide = "HomeSongs-module--carousel_slide--gbTRJ";